import {CssBaseline} from '@mui/material';
import {BrowserRouter, Navigate, Route, Routes} from 'react-router-dom';
import {GuardianComponent} from './pages/GuardianComponent';
import {StartIdentifyScam} from './pages/StartIdentifyScam';
import {ScenariosListPage} from './pages/Admin/ScenariosListPage';
import {AdminLayout} from './components/Admins/AdminLayout';
import {MainPage} from './pages/mainPage';
import {ScenariosNodeListPage} from './pages/Admin/ScenariosNodeListPage';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {LandingPage} from './components/LadingPages/LandingPage';
import {AppTutorialResponsiveSwitcher} from './components/Tutorials/TutorialOverlays/AppTutorialResponsiveSwitcher';
import {AppTutorialManager1} from "./components/Tutorials/TutorialOverlays/AppTutorialManager1";

function App() {
    return (<>
            <BrowserRouter>
                <CssBaseline/>
                {/*<AppTutorialResponsiveSwitcher/>*/}
                {/*<LanguageSwitcher/>*/}
                <AppTutorialManager1/>
                <Routes>
                    <Route path="/" element={<MainPage/>}>
                        <Route index element={<Navigate to="choose-guardian" replace/>}/>
                        <Route path="Home" element={<GuardianComponent/>}/>
                        <Route path="StartIdentifyScam" element={<StartIdentifyScam/>}/>
                        <Route path="choose-guardian" element={<GuardianComponent/>}/>

                        {/* Landing pages */}
                        <Route
                            path="archives"
                            element={
                                <LandingPage
                                    guardianImage="/assets/super_puppy_2.png"
                                    guardianName="Super Puppy"
                                    guardianMessage="Welcome to the Archives Vault. The Vault is currently under construction. This means that, for now, you cannot access your saved files from the Archives Vault. Any files you have saved will be saved into our databases and directly onto your computer. You can access your saved files directly from your machine in the location you have chosen to saved it in. The default saved file will be a time-stamped text file called interaction-history (time stamped).txt."
                                    copyrightInfo="Concept and Design by Brian R. Tan; Coding by Duc Le; Art by Hien & Ngoc; Guardian Illustration by Ai Nhan"
                                />
                            }
                        />
                        <Route
                            path="anti-scam-defenders"
                            element={
                                <LandingPage
                                    guardianImage="/assets/kungfu_bear_2.png"
                                    guardianName="Kungfu Bear"
                                    guardianMessage={`
                  You are in the "anti-scam defenses" function. This function is currently under construction.
                  When completed, this is where we use Artificial Intelligence to utilize information collected to provide with scam blocking and filtering defenses. 
                  You can also check for known scams that have been recorded in our databases. Please note that AI relies on data and cannot provide with full protection. 
                  You should use our scam checking function if you have specific information like a phone number or email to check for known reported scams. 
                  To protect yourself from any scam, we recommend using our scam identification function as this utilize a logic approach that is robust when the process is followed correctly.`}
                                />
                            }
                        />
                        <Route
                            path="contribution-community"
                            element={
                                <LandingPage
                                    guardianImage="/assets/poodie_and_panda_1.png"
                                    guardianName="Poodie and Panda"
                                    guardianMessage={`Welcome to the "Contribution & Community" area. This area is currently under construction. When completed, this is where you can access links to forums and communities talking about scams and how to protect yourself from scams. 
                  You can also choose to "report a scam" here, or donate to vetted individuals and organizations actively trying to bring the fight to the scammers.`}
                                />
                            }
                        />
                        <Route
                            path="scam-education"
                            element={
                                <LandingPage
                                    guardianImage="/assets/cyborg-bear-1.png"
                                    guardianName="Cyborg Bear"
                                    guardianMessage="Welcome to the Scam Education Center. We are currently under construction. When we open, we will offer all kinds of services related to scam education. There will be scam statistics, a list of common scams, quizzes to test your scam knowledge and preparedness, tips and advice on how to develop an anti-scam mentality, and much more. You will also be able to start Scam Protect's Introduction Tutorial from here in future"

                                />
                            }
                        />
                    </Route>

                    <Route path="/admin" element={<AdminLayout/>}>
                        <Route path="ScenariosList" element={<ScenariosListPage/>}/>
                        <Route path="ScenariosNodeList" element={<ScenariosNodeListPage/>}/>
                    </Route>
                </Routes>
            </BrowserRouter>
        </>
    );
}

export default App;
